import React from "react";
import "./Authorize.css";

const Authorize = () => {
  return (
    <div id="authorize">
      <h1 className="authorize-heading">Authorize zocket?</h1>
      <p className="authorize-subHeading">
        Application requires following permissions
      </p>
      <div className="authorize-details">
        <p className="authorize-details-heading">
          Allow Zocket app to access following details:
        </p>
        <ul className="authorize-list">
          <li className="authorize-list-item">Email ID</li>
          <li className="authorize-list-item">Phone number</li>
        </ul>
      </div>
      <div className="authorize-btns">
        <button className="authorize-btn-cancel">Cancel</button>
        <button className="authorize-btn-authorize">Authorize</button>
      </div>
    </div>
  );
};

export default Authorize;
